import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isActive"];
// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template-activatable/src/index.tsx
import React from 'react';
import baseIcon, { navigationActivatableDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var NavigationIconFeedPath = 'M22 3H8a3 3 0 00-3 3v18a3 3 0 003 3h14a3 3 0 003-3V6a3 3 0 00-3-3zm0 22H8a1 1 0 01-1-1V6a1 1 0 011-1h14a1 1 0 011 1v18a1 1 0 01-1 1zm-3-4h-8v-6h8v6zm2 2H9V13h12v10zM16 9h5V7h-5v2zm-4-1a2 2 0 10-4.001.001A2 2 0 0012 8z';
var NavigationIconFeedActivePath = 'M16,9 L21,9 L21,7 L16,7 L16,9 Z M9,23 L21,23 L21,13 L9,13 L9,23 Z M8,8 C8,6.896 8.896,6 10,6 C11.104,6 12,6.896 12,8 C12,9.104 11.104,10 10,10 C8.896,10 8,9.104 8,8 L8,8 Z M22,3 L8,3 C6.343,3 5,4.343 5,6 L5,24 C5,25.657 6.343,27 8,27 L22,27 C23.657,27 25,25.657 25,24 L25,6 C25,4.343 23.657,3 22,3 L22,3 Z';
var NavigationIcon = baseIcon('NavigationIconFeed', {
  getPath: _ref => {
    var {
      isActive
    } = _ref;
    return isActive ? NavigationIconFeedActivePath : NavigationIconFeedPath;
  },
  styleSheetPropsGetter: (_ref2, designVersion) => {
    var {
      isActive,
      color,
      colorToken,
      colorTokenArgs
    } = _ref2;
    return {
      isActive,
      color,
      designVersion,
      colorToken,
      colorTokenArgs
    };
  },
  defaultStyleSheetGetter: navigationActivatableDefaultStyleSheetGetter,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  restOfPropsSanitizer: _ref3 => {
    var {
        isActive
      } = _ref3,
      restOfProps = _objectWithoutProperties(_ref3, _excluded);
    return restOfProps;
  },
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
var NavigationIconFeed = props => {
  useDeprecationWarning({
    componentName: 'NavigationIconFeed',
    removalDate: 'v6.0.0'
  });
  return /*#__PURE__*/React.createElement(NavigationIcon, props);
};
NavigationIconFeed.displayName = 'NavigationIconFeed';
export default NavigationIconFeed;
//# sourceMappingURL=index.js.map